module.exports = __webpack_public_path__ + "img/地热国2_1.53658529.png";